import { Box, Grid, Typography } from '@mui/material';
import { intelligentProcurementItems } from './data';

const IntelligentProcurement = () => {
  return (
    <div style={{ paddingBlock: '1rem' }}>
      <div className='page__content'>
        <Typography
          color='#3A3E50'
          fontWeight={600}
          fontSize={{ xs: 26, lg: 44 }}
          textAlign={'center'}
          mb={4}
          mx={'auto'}
          maxWidth={'30ch'}
          lineHeight={1}
          component='h2'
        >
          Everything You Need for <span style={{ color: '#005FCC' }}>Intelligent Procurement</span>
        </Typography>
      </div>

      <div style={{ position: 'relative' }}>
        <Box
          sx={{
            display: {
              xs: 'none',
              sm: 'none',
              md: 'block',
              lg: 'block',
              xl: 'block',
            },
            width: '100%',
            height: '64px',
            position: 'absolute',
            left: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            backgroundColor: '#0067E2',
            zIndex: 1,
          }}
        ></Box>
        <div className='page__content' style={{ position: 'relative', zIndex: 2 }}>
          <Grid container spacing={{ xs: 1, lg: 3 }}>
            {intelligentProcurementItems.map(item => (
              <Grid item key={item.title} xs={12} sm={12} md={4} lg={4} xl={4} pb={2}>
                <Box
                  sx={{
                    boxShadow: '0px 0px 40px 0px #0017721A',
                    backgroundColor: '#fff',
                    p: 2,
                    borderRadius: '20px',
                    height: '100%',
                  }}
                >
                  <Box display={'flex'} alignItems={'center'} gap={1} mb={1} color={'#070A0D'}>
                    <item.icon sx={{ fontSize: 44 }} />
                    <Typography
                      fontWeight={600}
                      fontSize={{ xs: 14, lg: 18 }}
                      lineHeight={1.2}
                      maxWidth={'25ch'}
                      component='h3'
                    >
                      {item.title}
                    </Typography>
                  </Box>
                  <Typography color='#1D2935' fontWeight={400} fontSize={{ xs: 12, lg: 16 }} lineHeight={1.5}>
                    {item.description}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default IntelligentProcurement;
